export const routes = {
    DEFAULT: '/tourservice',
    TOURSERVICE: '/tourservice',
    LIVEMONITOR: '/livemonitor',
} as const;
